import React, { useEffect, useMemo, useState } from "react";
import { Helmet } from "react-helmet";
import { connect, useDispatch, useSelector } from "react-redux";
import { useLocation, withRouter } from "react-router-dom";
import StepWizard from "react-step-wizard";
// images
import Cookies from "universal-cookie";
import superagent from "superagent";
import { toast } from "react-toastify";
import menuBg from "../../assets/images/bg/menu/account.svg";
import FooterBottom from "../../components/footerBottom";
// components
import Header from "../../components/header";
import MainMenu from "../../components/mainMenu";
import { accountVerifyAction } from "./actions";
import FinishSetup from "./components/finishSetup";
import MemberProfile from "./components/memberProfile";
import MemberProfile2 from "./components/memberProfile2";
import ProfilePhoto from "./components/profilePhoto";
import "./style.scss";
import MemberSuccess from "./components/MemberSuccess";
import { base_url } from "../../utils/constants";
import { checkEmptyObject } from "../../utils/commonFunctions";

import stepBg1 from "../../assets/images/bg/account/step1.jpg";
import stepBg2 from "../../assets/images/bg/account/step2.jpg";
import stepBg3 from "../../assets/images/bg/account/step3.jpg";
import outer from "../../assets/images/account/outer.jpg";

const cookie = new Cookies();

function AccountComplete(props) {
  const { history } = props;
  const { search } = useLocation();
  const query = new URLSearchParams(search);
  const token = query.get("token");
  const userId = query.get("id");
  const expires = query.get("expires");
  const signature = query.get("signature");
  const secretToken = query.get("secret_token");
  const stripeUrl = query.get("stripe_url");
  const coupon = query.get("coupon");
  const couponUrl = query.get("coupon_url");
  const redirectUrl = query.get("redirect_url");
  const planStripeUrl = query.get("plan_url");
  const [openMenu, setOpenMenu] = useState(false);
  const [getActiveStep, setGetActiveStep] = useState(1);
  const [membership, setMembership] = useState(false);
  const userInfo = useSelector((state) => state?.my_account?.user_info);

  const dispatch = useDispatch();

  const handleOpenMenu = () => {
    setOpenMenu(!openMenu);
  };

  const handleCloseMenuMenu = () => {
    setOpenMenu(false);
  };
  useEffect(() => {
    if (stripeUrl && userInfo?.is_free_trial === 0 && !checkEmptyObject(userInfo) && userInfo?.email_verified_at) {
      superagent
        .get(`${base_url}trial-subscription?plan=PRO&type=free-trial`)
        .set("accept", "application/json")
        .set("Authorization", cookie.get("user_token"))
        .end((_err, res) => {
          window.location = res.body.url;
        });
    } else if (!cookie.get("user_token")) {
      window.location = "/login";
    } else if ((cookie.get("user_info")?.is_complete === 1 || cookie.get("user_info")?.is_complete === true) && userInfo?.email_verified_at) {
      window.location.replace("/my-account");
    }
  }, [history, stripeUrl, userInfo]);

  useEffect(() => {
    if (couponUrl && coupon) {
      history.push(`${couponUrl}&coupon=${coupon}`);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [couponUrl, coupon, userInfo]);
  console.log("planStripeUrl", history, `${planStripeUrl}${history?.location?.search?.hash}`);
  useEffect(() => {
    cookie.remove("verify_email");

    if (!cookie.get("user_token")) {
      window.location = "/login";
    } else if ((cookie.get("user_info")?.is_complete === 1 || cookie.get("user_info")?.is_complete === true) && userInfo?.email_verified_at) {
      window.location.replace("/my-account");
    }

    if (userInfo?.auth_token && token && userId && expires && signature && userId?.toString() === userInfo?.id?.toString()) {
      dispatch(accountVerifyAction(userId, token, expires, signature, secretToken, history, stripeUrl));
    }

    if (userInfo?.auth_token && token && userId && expires && signature && userId?.toString() !== userInfo?.id?.toString() && userInfo?.id) {
      toast.error("Link doesn't belong from this account.");
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, userInfo?.auth_token]);
  useEffect(() => {
    if (cookie.get("user_token") && !planStripeUrl && redirectUrl && userInfo?.email_verified_at) {
      window.location = `${redirectUrl}`;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userInfo?.email_verified_at]);

  useEffect(() => {
    if (cookie.get("user_token") && planStripeUrl && history?.location?.hash && userInfo?.email_verified_at) {
      window.location = `${planStripeUrl}${history?.location?.hash}`;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userInfo?.email_verified_at]);

  const [active, setActive] = useState(1);
  const getBackground = useMemo(() => {
    switch (active) {
      case 1:
        return stepBg1;
      case 2:
        return stepBg2;
      case 3:
        return stepBg3;
      case 4:
        return stepBg1;
      case 5:
        return outer;
      default:
        return stepBg1; // Replace defaultBackground with your actual default value or handle the case as needed.
    }
  }, [active]);

  return (
    <>
      <Helmet>
        <title>Finish Account Setup - Clarity Cooperative</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <Header openMenu={handleOpenMenu} className="headerStyleWhite" logoWhite />
      <MainMenu closeMenu={handleCloseMenuMenu} title="NAVIGATE" bgImage={menuBg} className={openMenu ? "active" : ""} />
      <div
        style={{
          backgroundImage: `url(${getBackground})`,
          backgroundSize: "cover",
        }}
        className="p-0 d-block"
      >
        <div className="w-100 h-100 overflow-hidden">
          <StepWizard onStepChange={({ activeStep }) => setActive(activeStep)}>
            <FinishSetup activeStep={setGetActiveStep} getActiveStep={getActiveStep} />
            <MemberProfile activeStep={setGetActiveStep} getActiveStep={getActiveStep} />
            <ProfilePhoto activeStep={setGetActiveStep} getActiveStep={getActiveStep} />
            <MemberProfile2 membership={membership} setMembership={setMembership} activeStep={setGetActiveStep} getActiveStep={getActiveStep} />
            {membership && <MemberSuccess />}
          </StepWizard>
        </div>
      </div>
      <FooterBottom />
    </>
  );
}

export default connect(null, { accountVerifyAction })(withRouter(AccountComplete));
